import { useState } from "react";
import { hideUnsubmittedAfterSchema, type HideUnsubmittedAfter } from "../../../../../../shared/schema";

export const useHideAfterInput = (value: HideUnsubmittedAfter, onChange: (value: HideUnsubmittedAfter) => void) => {
  // Holds what the admin is typing so the field can be cleared and retyped; only whole amounts >= 1 are saved
  const [amountDraft, setAmountDraft] = useState<string | null>(null);

  const handleAmountChange = (raw: string) => {
    setAmountDraft(raw);
    const amount = Number(raw);
    if (raw !== "" && Number.isInteger(amount) && amount >= 1) onChange({ ...value, amount });
  };

  const handleUnitChange = (raw: string) => {
    const unit = hideUnsubmittedAfterSchema.shape.unit.safeParse(raw);
    if (unit.success) onChange({ ...value, unit: unit.data });
  };

  return {
    amountInputValue: amountDraft ?? String(value.amount),
    handleAmountChange,
    handleAmountBlur: () => setAmountDraft(null),
    handleUnitChange,
  };
};
